// extracted by mini-css-extract-plugin
export default {"container":"store-quick-view-header__container___3LSSs","title":"store-quick-view-header__title___32V5W","pitpass-logo":"store-quick-view-header__pitpass-logo___1yjtN"};